import React from "react";
import "../../modules/products/productDetail.css";
const ProductBasic = ({ basicDetails }) => {
  return (
    <>
      <div className="mb-4">
        <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
          Basic Details
        </div>
        <div className="product-details-container">
          <div className="container-div">
            <span className="label-id color_747f9e">Product ID</span>
            <span className="id-number">{basicDetails.product_id}</span>
          </div>
          <div className="container-div">
            <span className="label-id color_747f9e">Company’s Product ID</span>
            <span className="id-number">
              {basicDetails.company_product_id
                ? basicDetails.company_product_id.charAt(0).toUpperCase() + basicDetails.company_product_id.slice(1)
                : '--'}
            </span>
          </div>
          <div className="container-div">
            <span className="label-id color_747f9e">Product Name</span>
            <span className="id-number">{basicDetails.product_name}</span>
          </div>
          <div className="container-div">
            <span className="label-id color_747f9e">Division Name</span>
            <span className="id-number">
              {basicDetails?.vendorDivision?.name}
            </span>
          </div>
        </div>
      </div>
      <div className="mb-4">
        <div className="d-flex text-left px-3 my-3 py-1 form-sub-details fw_600">
          Packaging Details Per Piece
        </div>
        <div className="product-details-container">
          <div className="container-div">
            <span className="label-id color_747f9e">Type of Packaging</span>
            <span className="id-number">
              {basicDetails?.productPackingDetail?.packingType?.name}
            </span>
          </div>
          {/* <div className="container-div">
            <span className="label-id color_747f9e">Holding Value</span>
            <span className="id-number">
              {basicDetails?.productPackingDetail?.holding_value}
            </span>
          </div> */}
          <div className="container-div">
            <span className="label-id color_747f9e">Shipper Pack Quantity</span>
            <span className="id-number">
              {basicDetails?.productPackingDetail?.ships_box_quantity ?? "--"}
              <span className="ms-1">
                {basicDetails?.productPackingDetail?.holding_value_unit}
              </span>
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductBasic;
